import { useMemo } from 'react';

import { Permission } from '@/helpers/permissions';
import { useUserStore } from '@/store/Userdetails';

export interface UserPermissions {
  // false until the login response has filled the store
  userPermissionsLoaded: boolean;
  userCan: (permission: Permission) => boolean;
  userCanAny: (permissions: Permission[]) => boolean;
  userCanAll: (permissions: Permission[]) => boolean;
}

// The signed-in user's permissions. The Set is built once per login payload, so every check after that is a lookup.
export const usePermissions = (): UserPermissions => {
  const codes: string[] | undefined = useUserStore((state: any) => state.userData?.data?.responseData?.userData?.permissions?.[0]);

  return useMemo(() => {
    const granted = new Set(codes ?? []);
    const userCan = (permission: Permission) => granted.has(permission);
    return {
      userPermissionsLoaded: granted.size > 0,
      userCan,
      userCanAny: (permissions: Permission[]) => permissions.some(userCan),
      userCanAll: (permissions: Permission[]) => permissions.every(userCan),
    };
  }, [ codes ]);
};
